/* ============================================================
   LONAR DÉCOR — brand interactions (vanilla, no deps)
   Cart / ATC / variants are handled by the theme's own custom
   elements. This file only powers the brand's presentational
   flourishes. Every block guards for missing elements and is
   safe to run multiple times (idempotent) so it re-initialises
   for sections loaded in the Theme Editor.
   ============================================================ */
(function () {
  'use strict';
  var rm = matchMedia('(prefers-reduced-motion:reduce)').matches;
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---- reveal on scroll ---- */
  function initReveal(root) {
    var els = $$('.lonar-reveal', root).filter(function (el) { return !el.dataset.lonarRevealed; });
    if (!els.length) return;
    if ('IntersectionObserver' in window && !rm) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
        });
      }, { threshold: .12, rootMargin: '0px 0px -7% 0px' });
      els.forEach(function (el) { el.dataset.lonarRevealed = '1'; io.observe(el); });
    } else {
      els.forEach(function (el) { el.dataset.lonarRevealed = '1'; el.classList.add('is-in'); });
    }
  }

  /* ---- marquee: clone content once for a seamless loop ---- */
  function initMarquee(root) {
    $$('.lonar-marquee', root).forEach(function (m) {
      if (m.dataset.lonarMarquee) return;
      m.dataset.lonarMarquee = '1';
      var html = m.innerHTML;
      m.innerHTML = html + html; /* two copies → translateX(-50%) loops seamlessly */
    });
  }

  /* ---- horizontal product rail: drag + prev/next ---- */
  function initRails(root) {
    $$('.lonar-rail', root).forEach(function (rail) {
      if (rail.dataset.lonarRail) return;
      rail.dataset.lonarRail = '1';
      var scope = rail.closest('[data-lonar-rail-scope]') || rail.parentNode;
      var step = function () {
        var card = rail.firstElementChild;
        return card ? card.getBoundingClientRect().width + 18 : 300;
      };
      var next = scope.querySelector('[data-lonar-rail-next]');
      var prev = scope.querySelector('[data-lonar-rail-prev]');
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
      var down = false, sx = 0, sl = 0, moved = false;
      rail.addEventListener('pointerdown', function (e) { down = true; moved = false; rail.classList.add('is-drag'); sx = e.pageX; sl = rail.scrollLeft; });
      addEventListener('pointerup', function () { down = false; rail.classList.remove('is-drag'); });
      rail.addEventListener('pointermove', function (e) {
        if (!down) return;
        if (Math.abs(e.pageX - sx) > 4) moved = true;
        rail.scrollLeft = sl - (e.pageX - sx);
      });
      /* prevent accidental link navigation after a drag */
      rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---- shoppable hotspots: exclusive toggle within a gallery ---- */
  function initHotspots(root) {
    $$('.lonar-gallery__img', root).forEach(function (gallery) {
      if (gallery.dataset.lonarHotspots) return;
      gallery.dataset.lonarHotspots = '1';
      var spots = $$('.lonar-hotspot', gallery);
      spots.forEach(function (h) {
        h.addEventListener('click', function (e) {
          e.preventDefault();
          var was = h.classList.contains('is-on');
          spots.forEach(function (x) { x.classList.remove('is-on'); });
          if (!was) h.classList.add('is-on');
        });
      });
    });
  }

  /* ---- custom-order steps + decorative drop zones ---- */
  function initCustom(root) {
    var steps = $$('.lonar-cstep', root);
    steps.forEach(function (s) {
      if (s.dataset.lonarStep) return;
      s.dataset.lonarStep = '1';
      s.addEventListener('click', function () {
        var group = $$('.lonar-cstep', s.closest('.lonar-custom') || root);
        group.forEach(function (x) { x.classList.remove('is-on'); });
        s.classList.add('is-on');
      });
    });
    $$('.lonar-drop', root).forEach(function (d) {
      if (d.dataset.lonarDrop) return;
      d.dataset.lonarDrop = '1';
      var toggle = function () { d.classList.toggle('is-filled'); };
      d.addEventListener('click', toggle);
      d.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
      });
    });
  }

  /* ---- lightweight accordion (opt-in via [data-lonar-acc]) ---- */
  function initAccordions(root) {
    $$('[data-lonar-acc]', root).forEach(function (acc) {
      if (acc.dataset.lonarAccInit) return;
      acc.dataset.lonarAccInit = '1';
      var head = acc.querySelector('[data-lonar-acc-head]');
      var body = acc.querySelector('[data-lonar-acc-body]');
      if (!head || !body) return;
      if (acc.classList.contains('is-open')) body.style.maxHeight = body.scrollHeight + 'px';
      head.addEventListener('click', function () {
        var open = acc.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : 0;
      });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initMarquee(root);
    initRails(root);
    initHotspots(root);
    initCustom(root);
    initAccordions(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme Editor: re-init only the freshly loaded section */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
